import styled from 'styled-components';
import { ReactComponent as FolderIcon } from 'Images/empty-folder.svg';

export const Badge = styled.div`
  display: flex;
  align-items: center;
  height: 26px;
  border-radius: 2px;
  overflow: hidden;

  border: 1px solid #1c4566;
  background: #eef2f6;
  color: #1c4566;

  user-select: none;
  margin-left: 6px;
  padding: 0 10px;
  gap: 6px;
  
  font-size: 14px;
  font-weight: 600;
`;
Badge.displayName = 'Badge';

export const Icon = styled(FolderIcon)`
  width: 14px;
  height: 14px;
  opacity: 0.9;
  &:hover { 
    cursor: default;
  }
  & path { fill: currentColor !important; }
`;
Icon.displayName = 'Icon';

export const Text = styled.span`
  line-height: 1;
`;
Text.displayName = 'Text';
